export default defineNuxtRouteMiddleware(to => {
  const user = useStrapiUser()

  if (!user.value) {
    const redirect = useCookie('redirect', { path: '/' })
    redirect.value = to.fullPath
    return navigateTo({ hash: '#connexion', path: '/' })
  }
})
